// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { useSelector } from 'react-redux'

const useCanUserComment = (isNewEntity, pathComment, requiredRole) => {
  // if the requiredRole is null, then the user is automatically authorized to comment.
  // but if it's not null, check against the user's permissions.
  const authorizedUser = useSelector(({ user }) => (
    requiredRole === null ||
    user.getIn(['permissions', requiredRole])
  ))

  return (
    authorizedUser &&
    isNewEntity === false
  )
}

export default useCanUserComment
